import { GoPerson } from 'react-icons/go';
import { CiWallet } from 'react-icons/ci';
import { FiSettings, FiTarget } from 'react-icons/fi';

export const profileTabs = [
  { name: 'Profile Page', id: 'profilePage', icon: <GoPerson size={20} /> },
  {
    name: 'Plan & Billing',
    id: 'planAndBilling',
    icon: <CiWallet size={20} />,
    adminOnly: true,
  },
  {
    name: 'Team Settings',
    id: 'teamSettings',
    icon: <FiSettings size={20} />,
    adminOnly: true,
  },
  {
    name: 'Productivity Apps',
    id: 'productivityApps',
    icon: <FiTarget size={20} />,
    adminOnly: true,
  },
];
